import {
  useWSModalCustom,
  WSCard,
  WSElement,
  WSInfoBox,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { AccountExpand } from "@wingspanhq/wingspan-api-sdk";
import { queriesAccounts } from "@query";
import { useSession } from "@hooks/useSession";
import { useInstantPayoutFee } from "../../hooks/useInstantPayoutFee";
import { InstantPayoutPayoutCA } from "../InstantPayoutPayoutCA";
import { InstantPayoutPayoutUS } from "../InstantPayoutPayoutUS";

type Props = WSModalCustomProps<void>;

export const ModalInfo: React.FC<Props> = props => {
  const { accountId } = useSession();
  const ipFee = useInstantPayoutFee();
  const queryAccount = queriesAccounts.getAccount.useQuery(
    { accountId, expand: [AccountExpand.COMPLIANCE_ENTITY] },
    { enabled: !!accountId }
  );

  const isInternational =
    queryAccount.data?.complianceEntity?.address?.country === "CA";

  return (
    <WSModal
      title={`Instant payout methods (${ipFee}% fee)`}
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Tertiary",
            onClick: () => {
              props.onClose();
            },
            label: "Done"
          }
        ]
      }}
      {...props}
    >
      <WSList gap="2XL">
        <WSInfoBox>
          The following account(s) may have instant payouts available. Please
          check your financial institution's online banking portal, as some
          banks may require you to opt in or enable the service manually.
        </WSInfoBox>

        {isInternational ? (
          <WSElement>
            <WSText.Caption weight="medium" mb="M">
              Canada
            </WSText.Caption>
            <WSCard>
              <InstantPayoutPayoutCA />
            </WSCard>
          </WSElement>
        ) : (
          <WSElement>
            <WSText.Caption weight="medium" mb="M">
              United States
            </WSText.Caption>
            <WSCard>
              <InstantPayoutPayoutUS />
            </WSCard>
          </WSElement>
        )}
      </WSList>
    </WSModal>
  );
};

export const useModalInfo = () => useWSModalCustom(ModalInfo);
